import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ClassroomService from "services/administration/classroom.service";
import { CourseView } from "../_courseView";
import { useStoreActions } from "easy-peasy";

const TRANSLATION_BASE_PATH = "_MARKETPLACE._SECTION_NEW_COURSES";
const MAX_ITEMS_TO_LOAD = 10;
const SECTION_SUBPATH = "new-courses";

export const SectionNewCourses = (props: any) => {
	const { t: translate } = useTranslation();
	const [items, setItems] = useState<any>([]);
	const [loading, setLoading] = useState(true);
	const [imagePrefix, setImagePrefix] = useState(null);
	const updateTotalNewItems = useStoreActions((actions: any) => actions.subjects.updateTotalNewItems);

	const loadData = () => {
		setLoading(true);
		props.handleSearchProgress(1);
		new ClassroomService()
			.getForMarketPlaceNewClassrooms({
				key: props.searchKey,
				limit: MAX_ITEMS_TO_LOAD,
				filters: props.filters
			})
			.then((result: any) => {
				setImagePrefix(result[0]);
				setItems(result[1]);
				updateTotalNewItems(result[2]);
			})
			.finally(() => {
				setLoading(false);
				props.handleSearchProgress(-1);
			});
	};

	useEffect(() => {
		loadData();
	}, [props.searchKey, props.filters, props.singleSection]);

	return (
		<CourseView
			title={translate(`${TRANSLATION_BASE_PATH}_TITLE`)}
			icon="ri-fire-line"
			items={items}
			imagePrefix={imagePrefix}
			loading={loading}
			showAllLink={props.singleSection ? null : SECTION_SUBPATH}
		/>
	);
};
